import React from "react";
import { Link } from "react-router-dom";
import { Anchor, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import HeroLayout from "@/components/hero/HeroLayout";

export default function PublicSeoHero({ hub, premiumLabel = "View Premium Tools" }) {
  return (
    <HeroLayout
      backgroundImage={hub.heroImage}
      overlay="dark"
      className="min-h-[420px] md:min-h-[460px] lg:min-h-[500px]"
      contentClassName="max-w-3xl [&_.hero-title]:text-[clamp(2.4rem,5vw,4.6rem)] [&_.hero-subtitle]:text-base md:[&_.hero-subtitle]:text-lg"
      eyebrow={(
        <Badge className="border-white/30 bg-white/15 text-white backdrop-blur-md">
          <Anchor className="mr-1 h-3 w-3" /> {hub.eyebrow}
        </Badge>
      )}
      title={hub.title}
      subtitle={hub.description}
      actions={(
        <>
          <Button asChild className="bg-white text-ocean hover:bg-white/90">
            <a href="#featured-public-pages">
              <Search className="h-4 w-4" />
              {hub.cta}
            </a>
          </Button>
          <Button asChild variant="outline" className="border-white/50 text-white hover:bg-white hover:text-ocean">
            <Link to="/premium">{premiumLabel}</Link>
          </Button>
        </>
      )}
    />
  );
}